import RouterView from '@/components/layout/Router.vue';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { teamPlayerExamResultRoute } from './examResult.route';
import { teamPlayerMedicalExaminationRoute } from './medicalExamination.route';

export const teamPlayerContainerRoute = {
  path: ':playerId',
  component: RouterView,
  meta: {
    title: 'titles.team.players',

    breadcrumb: {
      title: ''
    }
  },
  children: [teamPlayerMedicalExaminationRoute, teamPlayerExamResultRoute],
  beforeEnter: (to: any, from: any, next: any) => {
    store
      .dispatch('team/player/get', tryParseInt(to.params.playerId))
      .then(player => {
        teamPlayerContainerRoute.meta.breadcrumb.title = `${player.firstName} ${player.lastName}`;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.team.player.listError' }));
  }
};
